<h2>{{ "navigation_theme_title" | localize }}</h2>
<ui-radio-group [(ngModel)]="profileTheme" (ngModelChange)="themeChanged($event)">
  <label class="light" ui-radio uiValue="light">
    <span class="color-sample light"></span>
    <span class="label-text">Light</span>
  </label>
  <label class="gray" ui-radio uiValue="gray">
    <span class="color-sample gray"></span>
    <span class="label-text">Gray</span>
  </label>
  <label class="dark" ui-radio uiValue="dark">
    <span class="color-sample dark"></span>
    <span class="label-text">Dark</span>
  </label>
</ui-radio-group>
<onboarding
  *ngIf="onboarding && onboarding.shouldShow"
  [delegate]="onboarding.delegate"
  [steps]="onboarding.totalSteps"
  [startFromStep]="onboarding.startingStep"
  [previewOverrides]="onboarding.previewOverrides"
  [disableTracking]="true"
  section="navigation"
  popoverTitle="meet_the_new_nav"
  description="meet_the_new_nav_text">
</onboarding>
